import type { Labels } from "./labels";

export const englishLabels: Labels = {
  layers: "Layers",
  layersSearch: "Search layers",
  layersMenu: "More actions",
  allOn: "All on",
  allOff: "All off",
  reset: "Reset",
  baseMaps: "Base map",
  objects: "Objects",
  otherLayers: "Other",
  legend: "Legend",
  grouping: "Grouping",
  groupingWarning: "Without grouping more than 2000 objects are drawn, the map may slow down.",
  opacity: "Opacity",
  zoomTo: "Zoom to",
  onlyThis: "Only this",
  zoomRange: "{min} – {max}",
  zoomToSee: "zoom in to see",
  groupsSuffix: "groups",
  loading: "Loading",
  loadFailed: "The layer could not be loaded",
  noLayers: "No layers available",
  noResults: "No results",
  hostDrawsLayers: "This map draws its own layers",
  objectsSuffix: "objects",
  selectedCount: "{count} selected",
  clearSelection: "Clear selection",
  close: "Close",
  copy: "Copy",
  copied: "Copied",
  coordinates: "Coordinates",
  address: "Address",
  layer: "Layer",
  picture: "Picture",
  noPicture: "No picture",
  objectNotFound: "Object not found",
  members: "{count} objects at this place",
  featureTitle: "Map feature",
  featureChooser: "Several features at this point",
  featureSave: "Save",
  featureSaved: "Saved",
  featureSaveFailed: "Saving failed",
  featureNoFields: "This feature carries no data",
  featureLoadFailed: "The feature could not be loaded",
  photos: "Photos",
  addPhoto: "Add photo",
  removePhoto: "Remove photo",
  uploadFailed: "Upload failed",
  photoOf: "Photo {index} of {count}",
  previous: "Previous",
  next: "Next",
  routeTo: "Route here",
  routeFailed: "No route found",
  locationUnavailable: "Your location is not available",
  yes: "yes",
  no: "no",
  drawPoint: "Point",
  drawLine: "Line",
  drawPolygon: "Area",
  drawFinish: "Done",
  drawCancel: "Cancel",
  drawUndo: "Undo",
  drawRedo: "Redo",
  drawSnap: "Snap",
  drawSnapOff: "Snap off",
  drawReverse: "Reverse",
  drawSimplify: "Simplify",
  drawSimplifyTolerance: "Tolerance",
  drawMerge: "Merge",
  drawDelete: "Delete",
  drawVertexCount: "{count} points",
  drawSegment: "Segment",
  drawTotal: "Length",
  drawArea: "Area",
  drawPerimeter: "Perimeter",
  drawNeedsTwo: "A line needs at least two points",
  drawNeedsThree: "An area needs at least three points",
  drawSelfIntersects: "The area outline crosses itself",
  drawHintPoint: "Click the map to place the point, the marker can be dragged.",
  drawHintLine: "Click to add points, double click or Enter finishes, Esc cancels.",
  drawHintPolygon: "Click to add corners, double click or Enter finishes, Esc cancels.",
  drawHintEdit: "Drag the points, a midpoint inserts a point, right click removes. Alt+drag moves, Ctrl+click splits.",
  hintOk: "Got it",
  vertexTooltip: "Point {index}",
  midpointTooltip: "Drag to insert a point",
  measure: "Measure",
  measureDistance: "Distance",
  measureArea: "Area",
  measureClear: "Clear",
  measureHint: "Click to measure, double click finishes.",
  locate: "My location",
  locateFailed: "Location could not be determined",
  locateAccuracy: "Accuracy: {meters} m",
  fullscreen: "Fullscreen",
  exitFullscreen: "Exit fullscreen",
  fitView: "Full view",
  miniMap: "Overview map",
  zoomIn: "Zoom in (+)",
  zoomOut: "Zoom out (-)",
  searchPlaceholder: "Search",
  searchAddress: "Address",
  searchNoResults: "No results",
  searchFailed: "The search failed",
  searchMinimum: "At least four characters",
  resultsTab: "Results",
  resultsEmpty: "Search above or click the map",
  resultsFor: "Results for {term}",
  resultsCapped: "{layer}: only the first {count} results are shown, refine the search.",
  layerFeatures: "Layer features",
  coordinatesWgs: "WGS84",
  coordinatesEov: "EOV",
  coordinatesApproximate: "approximate, about 1 m",
  coordinatesSwitch: "Switch between WGS84 and EOV",
  scale: "Scale",
  trackPlay: "Play",
  trackPause: "Pause",
  trackSpeed: "Speed",
  errorUnauthorized: "Sign in required",
  errorForbidden: "No permission",
  errorNotFound: "Not found",
  errorNetwork: "The server cannot be reached",
  errorGeneric: "The request failed",
  serverErrorInvalidCredentials: "Wrong email address or password",
  serverErrorEmailNotConfirmed: "The email address is not confirmed yet, please click the link in the confirmation email",
  serverErrorInvalidEmail: "The email address is not valid",
  serverErrorDuplicateEmail: "A user with this email address already exists",
  serverErrorPasswordsDoNotMatch: "The two passwords do not match",
  serverErrorInvalidCurrentPassword: "The current password is wrong",
  serverErrorPasswordTooShort: "The password must be at least 6 characters",
  serverErrorPasswordRequiresDigit: "The password needs at least one digit",
  serverErrorPasswordRequiresLower: "The password needs at least one lowercase letter",
  serverErrorPasswordRequiresUpper: "The password needs at least one uppercase letter",
  serverErrorPasswordRequiresNonAlphanumeric: "The password needs at least one punctuation mark or other symbol",
  serverErrorPasswordRequiresUniqueChars: "The password needs more different characters",
  serverErrorInvalidToken: "The link is not valid or has expired",
  serverErrorNameRequired: "The name is required",
  serverErrorNameTooLong: "The name can be at most 200 characters",
  serverErrorNotApiKeyUser: "This user is not an API key user",
  serverErrorInvalidGraceMinutes: "The old key can stay valid for 0 to 10080 minutes",
  serverErrorApiKeyUserHasNoPassword: "An API key user cannot have a password",
  maps: "Maps",
  mapsSection: "Maps",
  layersSection: "Layers",
  othersSection: "Other",
  group: "Group",
  singleSelect: "Single choice",
  allLeaves: "All layers on",
  someLeaves: "Some layers on",
  truncatedHint: "The layer shows only part of its features, zoom in to see more",
  signIn: "Sign in",
  signOut: "Sign out",
  email: "Email",
  password: "Password",
  staySignedIn: "Stay signed in",
  loginFailed: "Sign in failed",
  admin: "Administration",
  adminMaps: "Manage maps",
  adminLayers: "Manage layers",
  adminUsers: "Manage users",
  adminRoles: "Manage roles",
  account: "Account",
  changePassword: "Change password",
  save: "Save",
  saving: "Saving",
  saved: "Saved",
  saveFailed: "Saving failed",
  cancel: "Cancel",
  delete: "Delete",
  confirmDelete: "Delete this item?",
  duplicate: "Duplicate",
  newGroup: "New group",
  newLeaf: "New layer",
  kind: "Kind",
  settings: "Settings",
  idName: "Identifier",
  name: "Name",
  order: "Order",
  visible: "Visible",
  hidden: "Hidden",
  problems: "Problems",
  noProblems: "No problems",
  validating: "Validating",
  folder: "Folder",
  sldLayer: "SLD layer",
  urlTemplate: "URL template",
  provider: "Provider",
  dark: "Dark",
  previewTile: "Preview tile",
  moveUp: "Move up",
  moveDown: "Move down",
  dragToMove: "Drag to move",
  users: "Users",
  roles: "Roles",
  active: "Active",
  inactive: "Inactive",
  createUser: "Create user",
  editUser: "Edit user",
  resetPassword: "Reset password",
  fullName: "Full name",
  phoneNumber: "Phone number",
  role: "Role",
  featureAccess: "Feature access",
  none: "None",
  readOnly: "Read only",
  full: "Full",
  loadingCatalogue: "Loading the map catalogue",
  catalogueFailed: "The map catalogue could not be loaded",
  retry: "Retry",
  offline: "Offline",
  embedBlocked: "Embedding is not allowed",
  share: "Share",
  copyLink: "Copy link",
  back: "Back",
  forward: "Forward",
  info: "Info",
  search: "Search",
  unsavedChanges: "Unsaved changes",
  theme: "Theme",
  selectedLayers: "{count} layers on",
  truncated: "Not every feature is shown, zoom in",
  dismiss: "Dismiss",
  more: "More",
  openPanel: "Open panel",
  closePanel: "Close panel",
  pinPanel: "Pin panel",
  unpinPanel: "Unpin panel",
  cursorPosition: "Cursor",
  mapCentre: "Centre",
  copyMachine: "Copy machine readable",
  noSelection: "Nothing selected",
  legendEmpty: "No legend",
  tabLayers: "Layers",
  tabInfo: "Info",
  pinned: "Pinned",
  unpin: "Unpin",
  pin: "Pin",
  themeLight: "Light",
  themeDark: "Dark",
  themeSystem: "System",
  language: "Language",
  compactView: "Compact view",
  collapseAll: "Collapse all",
  expandAll: "Expand all",
  breadcrumbSeparator: " › ",
  countFormat: "{count}",
  zoomRangeShort: "z{min}-{max}",
  panelTitle: "Maps and layers",
  selectedObject: "Selected item",
  openInWindow: "Open in a window",
  backToPanel: "Back to the side panel",
  layerTable: "Data as a table",
  tableRows: "{count} rows",
  zoomToRow: "Zoom to",
  refresh: "Refresh",
  exportCsv: "Export (CSV)",
  changedFrom: "Changed from",
  changedTo: "Changed to",
  apply: "Apply",
  mapsRoot: "Maps",
  layersRoot: "Layers",
  on: "on",
  filterLayers: "Filter by name",
  menu: "Menu",
  noTable: "This layer has no data table",
  zoomLevel: "Zoom level",
  clusterTitle: "{count} objects"
};
